import { onDocumentEvent } from '@app/utils/domHelpers'

function handleSubmitButton(event) {
  event.preventDefault()

  const form = document.querySelector('[data-behaviour~="export-form"]')

  form.submit()
}

export default () =>
  onDocumentEvent(
    document,
    'click',
    '[data-behaviour~="export-submit-button"]',
    handleSubmitButton
  )
